import EventEmitter from "eventemitter3";

const undoableEventEmitter = new EventEmitter();

export { undoableEventEmitter };
